import React from 'react';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import { PRODUCT_ICON_MAP } from '../../../product-subpage/productIcons';
import type { ProductSubpageConfig } from '../../../product-subpage/types';

export const PlatformAdvantages: React.FC<{
  advantages: ProductSubpageConfig['advantages'];
}> = ({ advantages }) => (
  <SiteSection id="advantages" tone="muted" className="platform-sub-advantages platform-sub-advantages--premium">
    <SiteSectionHeader
      eyebrow={advantages.eyebrow}
      title={advantages.title}
      align="center"
    />
    <ul className="platform-sub-advantages__grid">
      {advantages.items.map((item) => {
        const Icon = PRODUCT_ICON_MAP[item.icon];
        return (
          <li key={item.title} className="platform-sub-advantage-card">
            <span className="platform-sub-advantage-card__icon" aria-hidden>
              <Icon size={22} strokeWidth={1.75} />
            </span>
            <h3 className="platform-sub-advantage-card__title">{item.title}</h3>
            <p className="platform-sub-advantage-card__desc">{item.description}</p>
          </li>
        );
      })}
    </ul>
  </SiteSection>
);
